export default "__VITE_ASSET__Cijqn10F__"